import { ROUTING_PATH } from '@shared/constants/routingPath';

export const GatherContractsRoutes = {
  BUDGET: `/${ROUTING_PATH.BUDGET.INDEX}`,
  CHANGE_ORDER: `/${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.CHANGE_ORDER.INDEX}`,
  PURCHASE_ORDERS: `/${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.PURCHASE_ORDERS}`,
  VENDORS: `/${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.VENDORS}`,
};
